import { baseApi } from "./base";
import { staffQueries } from "./staff/staffQueries";
import { staffMutations } from "./staff/staffMutations";

const staffApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    ...staffQueries(builder),
    ...staffMutations(builder),
  }),
});

export const {
  useGetStaffQuery,
  useGetStaffByIdQuery,
  useInviteStaffMutation,
  useUpdateStaffMutation,
  useDeleteStaffMutation,
  useSuspendStaffMutation,
  useActivateStaffMutation,
} = staffApi;
